import SvgIcon from 'components/Luxkit/SvgIcon'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: stretch;
  align-items: center;
  width: ${rem(32)};
`

const Line = styled.div`
  background-color: ${(props) => props.theme.palette.neutral.default.five};
  flex: 1;
  height: 100%;
  width: 2px;
`

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => props.theme.palette.neutral.default.one};
  border-radius: 50%;
  padding: ${rem(6)};
`

interface Props {
  icon: typeof SvgIcon | null
}

export default function TimelineItem({ icon: Icon }: Props) {
  return (
    <Container>
      <Line />
      {Icon && <Circle>
        <Icon size="S" colour="neutral-eight" />
      </Circle>}
      <Line />
    </Container>
  )
}
